import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import './footer.css'

function Footer() {
  let location = useLocation();

  return (
    <React.Fragment>
      <footer className="text-info-footer text-center curve" >
        <svg className={location.pathname !== '/' ? 'footerSvgF4' : 'footerSvg'} xmlns="http://www.w3.org/2000/svg" width="1920" height="100%" viewBox="0 0 1920 353.83">
          <path id="Trazado_1" data-name="Trazado 1" d="M1920,9351.633H0V9110.5S311.9,8996.8,958.563,8996.8,1920,9110.5,1920,9110.5Z" transform="translate(0 -8996.802)" fill="#292929" />
        </svg>
        <Container className="margin-footer">
          <Row>
            <Col className="text-footer text-lighter m-2">Contáctanos</Col>
          </Row>
          <Row>
            <Col xs lg="4" className="mb-2 text-footer align-self-start">
                <div className='mb-2'>
                    {`México`}
                </div>                
                <div className='mb-2'>
                    {`Teléfono: 800 98 08 080`}
                </div>
                <div className='mb-3'>
                    {`Correo: `} 
                    <br />
                    <a
                        rel="noreferrer"
                        className="mail-footer"
                        href="mailto:comunidad@claropay.com"
                        target="_blank">
                        {`comunidad@claropay.com`}
                    </a>
                </div>
            </Col>


            <Col xs lg="4" className="mb-2 text-footer align-self-start">
                <div className='mb-2'>
                    {`Brasil`}
                </div>                
                <div className='mb-2'>
                    {`Telefone: 0800-882-9080`}
                </div>
                <div className='mb-3'>
                    {`Email: `} 
                    <br />
                    <a
                        rel="noreferrer"
                        className="mail-footer"
                        href="mailto:ajuda@claropay.com.br"
                        target="_blank">
                        {`ajuda@claropay.com.br`}
                    </a>
                </div>
            </Col>

            <Col xs lg="4" className="mb-2 text-footer align-self-start">
                <div className='mb-2'>
                    {`Colombia`}
                </div>                
                <div className='mb-2'>
                    {`Teléfono: Desde el móvil: 611: Opción 4 Claro giros y Claro Pay, seguido opción 2 Claro Pay. Desde números fijos: 60 1 7500500 Opción 4 Claro giros y Claro Pay seguido opción 2 Claro Pay.`}
                </div>
                <div className='mb-3'>
                    {`Correo: `} 
                    <br />
                    <a
                        rel="noreferrer"
                        className="mail-footer"
                        href="mailto:claropay@claro.com.co"
                        target="_blank">
                        {`claropay@claro.com.co`}
                    </a>
                </div>
            </Col>
          </Row>
          
          <Row>
            <Col className="m-2">
              <a href="https://www.facebook.com/ClaroPay-1920019471425013" rel="noreferrer" target="_blank"><Image src='images/facebook-footer.svg' className="icon-footer" /></a>
              <a href="https://twitter.com/claropay" rel="noreferrer" target="_blank"><Image src='images/twitter-footer.svg' className="icon-footer" /></a>
              <a href="https://www.instagram.com/claropay/" rel="noreferrer" target="_blank"><Image src='images/instagram-footer.svg' className="icon-footer" /></a>
            </Col>
          </Row>
          <Row>
            <Col className="text-footer text-lighter m-2">
              Ayuda | <Link to="/aviso-de-privacidad" className="anchor-style">Aviso de privacidad</Link> | <Link to="/terminos-y-condiciones" className="anchor-style">Términos y Condiciones</Link>
            </Col>
          </Row>
          <Row>
            <Col className="text-footer ">
              &copy; 2021
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>

  );
}

export default Footer;
